var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.914062,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EAE6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3550_31408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 20.9141C25.383 20.9141 20 26.2971 20 32.9141C20.603 48.8121 43.4 48.8081 44 32.9141C44 26.2971 38.617 20.9141 32 20.9141ZM33 37.9141V38.9141C32.995 40.2221 31.005 40.2211 31 38.9141V37.9141H30.732C29.665 37.9141 28.669 37.3401 28.134 36.4151C27.857 35.9361 28.021 35.3251 28.498 35.0491C28.977 34.7701 29.589 34.9361 29.864 35.4131C30.043 35.7231 30.375 35.9141 30.731 35.9141H32.999C33.996 35.9791 34.442 34.3641 33.355 34.1541L30.314 33.6471C26.812 32.9981 27.566 27.8941 30.999 27.9141V26.9141C31.005 25.6061 32.994 25.6071 32.999 26.9141V27.9141H33.267C34.334 27.9141 35.33 28.4891 35.865 29.4141C36.142 29.8921 35.978 30.5031 35.501 30.7801C35.021 31.0571 34.41 30.8931 34.135 30.4151C33.956 30.1061 33.624 29.9151 33.268 29.9151H31C30.003 29.8501 29.558 31.4651 30.644 31.6751L33.685 32.1821C37.187 32.8311 36.433 37.9341 33 37.9141Z",
    fill: "#6F4EF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3550_31408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20.9141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon0);
export default __webpack_public_path__ + "static/media/icon (0).9f65c976c12125e626d3b78dc3374ad0.svg";
export { ForwardRef as ReactComponent };